<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="alert-octagon"
    [title]="fatalErrorsKeys?.length + ' ошибок отправки'"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>
      <div class="text-muted px-5 mb-5 mt-5">Список контактов на которые не удалось отправить сообщения, они будут пропущены</div>
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let item of fatalErrorsKeys">
          <div class="row flex-nowrap">
            <div [innerHTML]="item | href" class="col text-eclipse">
            </div>
            <div class="col-auto">
              <span
                class="badge badge-{{color(fatalErrors[item])}}">{{langs['ru'][fatalErrors[item]] || fatalErrors[item]}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
